import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/IOSappdevelopment/Hero";
import DevelopServices from "../components/IOSappdevelopment/DevelopServices";
import Technology from "../components/IOSappdevelopment/Technology";
import Process from "../components/IOSappdevelopment/Process";
import IndustryBussinessjs from "../components/IOSappdevelopment/IndustryBussinessjs";
import Commitment from "../components/IOSappdevelopment/Commitment";
import Customers from "../components/IOSappdevelopment/Customers";
import Success from "../components/IOSappdevelopment/Success";
import PageTitle from "../components/IOSappdevelopment/PageTitle";

import '../assets/Webdevelopment.css';



const IOSappdevelopment = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<DevelopServices />
	    	<Technology />
	    	<Process />
	    	<IndustryBussinessjs />
	    	<Commitment />
	    	<Customers/>
	    	<Success />
	  </div>
	)
}

export default IOSappdevelopment;
